import React, { useEffect, useState } from 'react'
import DashboardCountCard from '../../../../components/DashBoard/DashboardCountCard'
import API from '../../../../ApiConfig'
import { DASHBOARD_DATA, GET_ISSUED_DATA_COUNT } from '../../../../Utils/constant'
import Charts from '../Charts.js'
import Each from '../../../../components/Each'
import { useDispatch, useSelector } from "react-redux";
import { Delay } from '../../../../Utils/helper'
import Loader from '../../../../components/Loader'
import AllUsersStyle from '../../AllUsers.module.css'
import cogoToast from "cogo-toast-react-17-fix";
import { DashBoardBanner } from '../../../../components/DashBoard/DashBoardBanner.js'
import { useNavigate } from 'react-router-dom'
import { fetchCart } from '../../../../Utils/Redux/CartSlice.js'

export default function IssuerDash() {
    const [data, setData] = useState([])
    const [keyList, setKeyList] = useState([])
    const User = useSelector(state => state.User)
    const [loading, setLoading] = useState(false)

    const [lastRecordUploadedDate, setLastRecordUploadedDate]=useState("")
    const navigate=useNavigate()

    const dispatch=useDispatch()
    const [countCards, setCountCards] = useState([{
        label: 'All \n Documents',
        count: 0,
        navigateto:"/dashboard/credentials"
    },
    {
        label: 'Issued \n Documents',
        count: 0,
        navigateto:"/dashboard/credentials"
    },
    {
        label: 'Draft \n Documents',
        count: 0,
        navigateto:"/dashboard/credentials"
    },
    {
        label: 'Pending \n Requests',
        count: 0,
        navigateto:"/dashboard/verification_requests",
        state:"pending_requests"
    },
    {
        label: 'Pending \n Appeals',
        count: 0,
        navigateto:"/dashboard/DocAppeals",
        state:"pending_on_issuer"
    }
    // {
    //     label: 'Change\n Requested',
    //     count: 0
    // }

    ])
    useEffect(() => {
        getDashData()
        getCount()
    }, [])
    useEffect(() => {
            dispatch(fetchCart(User.user_id));
        }, [dispatch, User])
    async function getDashData(state, time) {
        let url = DASHBOARD_DATA + User.id
        if (state || time) {
            url = url + '?last_days=' + time
            if (state) {
                url = url + '&state=' + state
            }
        }
        setLoading(true)
        await Delay()

        API.get(url)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    let resd = res.data.data
                    setData(resd)
                    setKeyList(Object.keys(res.data.data))
                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err?.response?.data?.detail);
            })
    }
    function getCount() {
        API.get(`${GET_ISSUED_DATA_COUNT}${`?issuer_company_id=${User.company_id}`}`)
            .then(res => {
                if (res.data.status === 200) {
                    let data = res.data.data
                    let { draft_count, published_count, all_count, pending_requests, pending_appeals } = data
                    let temp = [...countCards]
                    temp[0].count = all_count
                    temp[1].count = published_count
                    temp[2].count = draft_count
                    temp[3].count = pending_requests
                    temp[4].count = pending_appeals
                    setCountCards(temp)
                    setLastRecordUploadedDate(data.last_bulk_upload_date)
                }
            })
            .catch(err => {
                // console.log(err)
            })
    }


    return (
        <>
            <DashBoardBanner message={'Issue your Document'} button={'+ Issue Document'} navigateto={'/dashboard/credentials/issue-credentials'} lastUploadDate={lastRecordUploadedDate} />

            {/* <Loader isOpen={loading} /> */}
            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                <div className={AllUsersStyle.searchInputFrame}>
                <Each of={countCards} render={(item, index) => {
                    return <DashboardCountCard loading={loading} {...item} />
                }} />
                </div>
                <button className='btn btn-primary' onClick={()=>navigate("/dashboard/Help")} style={{fontSize:"18px", backgroundColor:"gray"}}>
                    Video Tutorial
                </button>
            </div>
            <Charts loading={loading} data={data} keyList={keyList} getDashData={getDashData} />
        </>
    )
}
